package com.neurobs.js.dom

import com.neurobs.js.util.RandomString
import org.scalajs.dom.{document, window}

import scala.scalajs.js

/**
 * Handles timers
 */
object Timer {
	private def timerFunction(intervalMs: Int, processor: () => Boolean, firstCall: Boolean): Unit = {
		if (firstCall || processor()) {
			window.setTimeout(() => timerFunction(intervalMs, processor, firstCall = false), intervalMs)
		}
	}

	/** Creates a recurring timer
	 *
	 * @param intervalMs Time out interval in milliseconds
	 * @param processor Function called on time out. The return value determines if
	 *                  another timer is set for the same interval and function.
	 */
	def create(intervalMs: Int, processor: () => Boolean): Unit = {
		timerFunction(intervalMs, processor, firstCall = true)
	}

	private def elementTimerFunction(intervalMs: Int, processor: () => Boolean, elementId: String, firstCall: Boolean): Unit = {
		if (firstCall || ((document.getElementById(elementId) != null) && processor())) {
			window.setTimeout(() => elementTimerFunction(intervalMs, processor, elementId, firstCall = false), intervalMs)
		}
	}

	/** Creates a recurring timer that fires as long as an element with the returned
	 * id string exists in the DOM document
	 *
	 * @param intervalMs Timer interval is milliseconds
	 * @param processor Function to call on time out. Return false to stop recurring events.
	 *                  This function is only called if an element with the returned id is
	 *                  still in the DOM document
	 * @return ID string to be used as the element id for some element added to the DOM document
	 */
	def createRecurringElementTimer(intervalMs: Int)(processor: () => Boolean): String = {
		val elementId = RandomString.generate(length = 16)
		elementTimerFunction(intervalMs, processor, elementId, firstCall = true)
		elementId
	}
	
}
